var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gls-pickup-points',{attrs:{"pickup-point":_vm.pickupPoint,"show-parcel-shops":0,"show-parcel-lockers":1},on:{"input":_vm.setPickupPoint}})}
var staticRenderFns = []

export { render, staticRenderFns }